export default __webpack_public_path__ + "static/media/svn-tool.63014d01.png";